import { render, staticRenderFns } from "./theme-card.vue?vue&type=template&id=4ed80b3f&scoped=true"
import script from "./theme-card.vue?vue&type=script&lang=js"
export * from "./theme-card.vue?vue&type=script&lang=js"
import style0 from "./theme-card.vue?vue&type=style&index=0&id=4ed80b3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed80b3f",
  null
  
)

export default component.exports